import {axiosInstanceHH} from "../index";

export const loadGroupFiles = async (formData: FormData, categoryId: number, vacancyCompanyId: number | null) =>  {
  return axiosInstanceHH.post<void>(`/load-resumes/${categoryId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    params: {
      vacancyCompanyId
    }
  })
}